
  import {
    Component,
    Model,
    Prop,
    Vue,
    Watch
  } from "vue-property-decorator";
  import Dialog from '@/components/dialog.vue';
  import addressSelect from '@/components/address-select.vue'
  import {
    createProviderReturnLogistics
  } from '@/api/logistics'

  @Component({
    name: 'refund-address-info',
    components: {
      'slz-dialog': Dialog,
      addressSelect
    }
  })
  export default class RefundAddressInfo extends Vue {
    @Model('change') isShow!: boolean;
    @Prop({
      default: 'create'
    }) private type!: string;
    @Prop({
      default: 0
    }) private id!: number;
    @Prop({
      default: ()=>{
        return {}
      }
    }) private currentData!: any;
    private title = '新建退货地址';
    private showDialog = false;
    private formData: any = {
      Id: 0,
      ReturnRecipient: '',//退货收件人,
      ReturnPhone: '',// 联系方式,
      ReturnProvince: '', // 退货省,
      ReturnCity: '',// 退货市,
      ReturnArea: '', // 退货区,
      ReturnAddress: '',// 退货地址
      Remark:''
    }

    @Watch('isShow')
    private onChangeShow(val: any) {
      this.showDialog = val;
      if (val) {
        
        // this.getDetail()
        this.formData = JSON.parse(JSON.stringify(this.currentData));
        // console.log(this.currentData,11,[this.formData.ReturnProvince, this.formData.ReturnCity, this.formData.ReturnArea])
      }
    }

    private handleClose() {
      this.formData = {
        Id: 0,
        ReturnRecipient: '',//退货收件人,
        ReturnPhone: '',// 联系方式,
        ReturnProvince: '', // 退货省,
        ReturnCity: '',// 退货市,
        ReturnArea: '', // 退货区,
        ReturnAddress: '',// 退货地址
        Remark:''
      }
      this.$emit('change', false)
    }

    // 获取省市信息
    private getAddress(list: string[]) {
      this.formData.ReturnProvince = list[0];
      this.formData.ReturnCity = list[1];
      this.formData.ReturnArea = list[2];
    }

    private isEmpty() {
      if (!this.formData.ReturnRecipient) {
        this.$message('请输入收件人姓名');
        return true;
      }
      if (!this.formData.ReturnPhone) {
        this.$message('请输入收件人联系方式');
        return true;
      }
      if (!this.formData.ReturnProvince || !this.formData.ReturnCity || !this.formData.ReturnArea || !this.formData.ReturnAddress) {
        this.$message('请输入详细地址');
        return true;
      }
      return false
    }

    private submit() {
      if (this.isEmpty()) return;
      this.doCreate();
    }

    private async doCreate() {
      try {
        await createProviderReturnLogistics(this.formData);
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.$emit('update');
        this.handleClose();
      } catch (e) {
        console.log(e);
      }
    }

    

    // private async getDetail() {
    //   try {
    //     const res: any = await getProviderReturnLogisticsDetail({
    //       id: this.id
    //     })
    //     this.formData = res.info;
    //   } catch (e) {
    //     console.log(e)
    //   }
    // }
  }
